/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notifications_Tags_Bell_CreateInputs */

const he_notifications_tags_bell_create = /** @type {(inputs: Notifications_Tags_Bell_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`קבלו התראות על הקטגוריות האלה`)
};

const en_notifications_tags_bell_create = /** @type {(inputs: Notifications_Tags_Bell_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Get notified about these categories`)
};

/**
* | output |
* | --- |
* | "Get notified about these categories" |
*
* @param {Notifications_Tags_Bell_CreateInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const notifications_tags_bell_create = /** @type {((inputs?: Notifications_Tags_Bell_CreateInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_Tags_Bell_CreateInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_notifications_tags_bell_create(inputs)
	return en_notifications_tags_bell_create(inputs)
});